import { SVGProps } from 'react';

const QuestionMarkInCircleFilledIcon = ({
  width = 18,
  height = 18,
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="var(--brand-bg-primary)"
      className={className}
      {...props}
      data-palette="QuestionMarkInCircleFilledIcon">
      <path
        d="M8.99984 17.3334C4.39746 17.3334 0.666504 13.6024 0.666504 9.00002C0.666504 4.39764 4.39746 0.666687 8.99984 0.666687C13.6022 0.666687 17.3332 4.39764 17.3332 9.00002C17.3332 13.6024 13.6022 17.3334 8.99984 17.3334ZM8.1665 11.5V13.1667H9.83317V11.5H8.1665ZM9.83317 10.1293C11.0379 9.77069 11.9165 8.6546 11.9165 7.33335C11.9165 5.72252 10.6107 4.41669 8.99984 4.41669C7.58484 4.41669 6.40514 5.42435 6.13926 6.76124L7.77384 7.08816C7.88784 6.51521 8.39342 6.08335 8.99984 6.08335C9.69017 6.08335 10.2498 6.64299 10.2498 7.33335C10.2498 8.02369 9.69017 8.58335 8.99984 8.58335C8.53959 8.58335 8.1665 8.95644 8.1665 9.41669V10.6667H9.83317V10.1293Z"
        fill="currentColor"
      />
    </svg>)
  );
};

export default QuestionMarkInCircleFilledIcon;
